export default "__VITE_ASSET__CARiSMRh__"